export default __webpack_public_path__ + "static/media/textIcon.d31e18ad.svg";